var mappingDataSource = (function () {

    var onDblClickDataSource = null;
    var setDblClickDataSource = function (callback) {
    }

    var getDataSourcePopover = function (type, target = null, title = null) {
        return {} as any;
    }

    var showDataSourcePopover = function (type, target, items = null, title = null) {
        
    };

    var tables = [];
    var metrics = [];

    var prepareDataSourcePopover = function (callback) {
        
    };

    var getField = function (fieldId) {
        return {} as any;
    }

    var getFieldByName = function (fieldName, fieldTableName) {
        return {} as any;
    }

    var getFieldName = function (fieldId) {
        return "";
    }

    var getMetricName = function (metricId) {
        return "";
    }

    var getAllMetrics = function () {
        return {} as any;
    }

    var hide = function () {
        
    }

    return {
        getDataSourcePopover: getDataSourcePopover,
        showDataSourcePopover: showDataSourcePopover,
        prepareDataSourcePopover: prepareDataSourcePopover,
        setDblClickDataSource: setDblClickDataSource,
        getMetricName: getMetricName,
        getField: getField,
        getFieldByName: getFieldByName,
        getFieldName: getFieldName,
        hide: hide,
        getAllMetrics: getAllMetrics
    };

}());
